import { projectClassId } from 'cd-eft/components/Projects/ProjectContainer/ProjectContainerVM';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { observable, action } from 'mobx';
import { invokeExportZipHandler } from '../../SurveyEngineering/Maps/SETMapFunctions/loadLayers';
import DelineateWatershedGpApi from 'cd-eft/services/DelineateWatershedGpApi/DelineateWatershedGpApi';
import stores from '../../../models/Stores';
import { appConfig } from 'cd-eft/config/AppConfig';
import { StructureProfileController, DesignElementExportController, SurfaceController, ActivityLogController, DesignElementController, WaterwayDesignToolsController, TerraceDesignToolsController, SurfaceDefController } from 'cd-eft/services/eftSetApi';
import { HydroControllerApi } from 'cd-eft/services/eftEfh2Api';
import { ICreateActivityLogPOST } from 'cd-eft/models/Projects/createActivityLog';
import { DesignElementDownloadDTO } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { HydrologyReportReqDto } from 'cd-eft/_codegen_/openapi-generator/eft-efh2';
import { ANALYSIS, DESIGN, OUTPUT_TABS, OUTPUT_TYPES, OUTPUT_fileFormats } from './DownloadProject.config';
import { selectImageTypeHandler, selectStructureHandler } from '../DownloadProjectImages/DownloadProjectImagesVM';
import { AxiosResponse } from 'axios';
import { feetToMeters, formatRoundSTrim } from 'cd-eft/utils/mathUtilities';

const { setEndpoints } = appConfig;
const { surveyEngineeringStore: setStore, projectsLibraryStore: libraryStore } = stores.AppStore;

interface TerraceCSVResponse {
  response: AxiosResponse;
  name: string;
}
interface SelectedTerraceData {
  terraceID: number, //el.alignedElementDesignParametersId,
  terraceCrossSection: number, //if Applicable for Terraces
  name: string,
}

export class DownloadProjectVM {
  @observable props;

  constructor(props: any) {
    this.props = props;
    this.watershedApi = new DelineateWatershedGpApi();
  }

  @observable project: any = {};
  @observable isLoading: boolean = false;
  @observable loadingMsg: string = '';
  @observable successProjectLoading: boolean = false;
  @observable error: boolean = false;
  @observable errorMsg: string = '';
  @observable successGeneratingFile: boolean = false;
  @observable validTypes: any[] = [];
  @observable fileLocation: string = '';
  @observable accessTokenDownloadLandXML: string = '';
  @observable additionalStations: boolean = true;
  @observable additionalStationsTerrace: boolean = true;
  @observable countByFormat: number = 0;
  @observable exportTerraceRequest: SelectedTerraceData[] = [];
  @observable capturedCSVs: TerraceCSVResponse[] = [];
  designTypeComments: any = [];
  watershedApi: DelineateWatershedGpApi;
  surfaceDefId: number = 0;
  initialformValidation = { formErrors: { fileFormat: '', selectedElements: '' } };
  @observable formValidation = { ...this.initialformValidation };
  // hydrology images
  @observable hydrologyImages: any[] = [];
  // Subtabs -->
  @observable tabs: any[] = [];
  @observable currentTabObject: any = {};
  @observable currentSubTab: string = DESIGN;

  @action.bound changeSubTab = (value) => {
    this.someChangesOnScreen();
    MessageCenter.clearMessages();
    this.currentSubTab = value;
    this.currentTabObject = OUTPUT_TABS[this.project.projectClassId].tabs.find((el) => el.tab === value);
    libraryStore.fileFormat = this.currentTabObject.options[0].value;
  };
  // <-- Subtabs
  retrevingFilesString = 'Retrieving files...'

  setLoader(value: string = '') {
    if (value.trim()) {
      this.isLoading = true;
      this.loadingMsg = value;
    } else {
      this.isLoading = false;
      this.loadingMsg = '';
    }
  }

  // ===================================================== Load data =====================================================
  @action.bound async onMount() {
    this.project = this.props.project;
    this.tabs = OUTPUT_TABS[this.project.projectClassId].tabs;
    this.currentTabObject = this.tabs[0];
    this.currentSubTab = this.currentTabObject.tab;
    libraryStore.fileFormat = this.currentTabObject.options[0].value;
    if (this.project.projectClassId === projectClassId.hydrology) {
      await this.getAllHydrologyImageCapturesBySession();
      this.selectedHydrologyType = OUTPUT_fileFormats[libraryStore.fileFormat].validTypes[0];
    }
    if (this.project.projectClassId === projectClassId.design) {
      await this.getAllDesignElementExportablesBySession();
    }

  }
  @action.bound async getAllHydrologyImageCapturesBySession() {
    this.setLoader('Loading image summary...');
    this.hydrologyImages = [];
    try {
      const response = await StructureProfileController.getHydroMapImagesByProjectUuidUsingGET(this.project.projectUuid);
      if (response.data) {
        response.data.forEach(image => {
          switch (image.imageTypeId) {
            case 1:
              this.hydrologyImages.push({ name: 'Plan view', image: image.images, selected: true });
              break;
            case 2:
              this.hydrologyImages.push({ name: 'Location view', image: image.images, selected: true });
              break;
            case 3:
              this.hydrologyImages.push({ name: 'Other view', image: image.images, selected: true });
              break;
            default:
              console.warn(`Unknown imageTypeId: ${image.imageTypeId}`);
          }
        });
      } else {
        console.error('Unexpected response format:', response);
      }
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
    } finally {
      if (!this.error) { this.error = false }
      this.setLoader('');
    }
  }

  @action.bound async getAllDesignElementExportablesBySession() {
    this.setLoader('Loading output summary...');
    const sessionUuid = [this.project.sessionList[0].sessionUuid];
    try {
      const response = await DesignElementExportController.getAllDesignElementExportablesBySessionUsingGET(
        sessionUuid.join(',')
      );
      const data = response.data;
      if (data) {
        if (data.designElementProjectResponseList && data.designElementProjectResponseList.length > 0) {
          this.getAllDesignElementsByProject(data.designElementProjectResponseList);
        }
        if (data.waterwayDesignSummaryDtoList && data.waterwayDesignSummaryDtoList.length > 0) {
          libraryStore.designElementsByType['Waterway'] = {};
          this.getWaterwaySummary(data.waterwayDesignSummaryDtoList);
        }
        if (data.terraceDesignSummaryDtoList && data.terraceDesignSummaryDtoList.length > 0) {
          libraryStore.designElementsByType['Terrace'] = {};
          this.getTerraceSummaryData(data.terraceDesignSummaryDtoList);
        }
        if (data.ugoDesignSummaryDtoList && data.ugoDesignSummaryDtoList.length > 0) {
          this.getUgoSummaryData(data.ugoDesignSummaryDtoList);
        }
        this.getTerraceSystemSummaryData();
        if (data.surfaceDefResponseList && data.surfaceDefResponseList.length > 0) {
          this.surfaceDefId = Number(data.surfaceDefResponseList[0].surfaceDefId);
          if (
            data.surfaceDefResponseList[0].surveyMetadata &&
            data.surfaceDefResponseList[0].surveyMetadata.length > 0
          ) {
            libraryStore.designElementsByType['Survey'] = {};
            this.getSurveySummary(data.surfaceDefResponseList[0].surveyMetadata);
          }
          if (data.surfaceDefResponseList[0].demSurfaceMetadata && data.surfaceDefResponseList[0].demSurfaceMetadata.length > 0) {
            libraryStore.designElementsByType['Survey - DEM Surface'] = {};
            this.getSurfaceDemSummary(data.surfaceDefResponseList[0].demSurfaceMetadata, data.designElementProjectResponseList);
          }
        }
      }
      this.countElementsByFormat();
      this.setLoader('Loading image summary...');
      for (const ty of OUTPUT_fileFormats['Images'].validTypes) {
        if (libraryStore.designElementsByType[ty] && libraryStore.designElementsByType[ty].designElements) {
          const itemsToCheck = libraryStore.designElementsByType[ty].designElements.filter((el) => el.isSelected);
          for (const item of itemsToCheck) {
            if (ty !== 'Terrace System') {
              await this.getImagesByDesignelement(item);
            }
          }
        }
      }
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
    } finally {
      this.error = false;
      this.setLoader('');
    }
  }

  @action.bound async getAllDesignElementsByProject(data) {
    // Loads generic elements
    libraryStore.designElementsByType = {};
    // Define the specific terrace type IDs from appConfig
    const terraceTypeIds = [
      appConfig.hardCodes.designElementTypeTerraceGradient, // 20
      appConfig.hardCodes.designElementTypeTerraceLevel,    // 21
      appConfig.hardCodes.designElementTypeTerraceStorage,  // 22
      appConfig.hardCodes.designElementTypeTerraceWascob,   // 23
    ];
    data.forEach((el: any) => {
      const typeId = el.designElementTypeId;
      if (terraceTypeIds.includes(typeId)) {
        this.getTerraceSummary(el);
      } else {
        // Handle other generic design element types
        libraryStore.designElementsByType[typeId] = { ...el };
        if (libraryStore.designElementsByType[typeId].designElements) {
          libraryStore.designElementsByType[typeId].designElements.forEach((de) => {
            de.isSelected = true;
          });
        } else {
          // Handle cases where designElements might be missing for a type
          libraryStore.designElementsByType[typeId].designElements = [];
          libraryStore.designElementsByType[typeId].size = 0;
        }
      }
    });
    this.successProjectLoading = true;
    this.countElementsByFormat();
  }

  @action.bound getTerraceSummary = (terraceData: any) => {
    const typeId = terraceData.designElementTypeId;

    // Ensure the entry exists
    if (!libraryStore.designElementsByType[typeId]) {
      libraryStore.designElementsByType[typeId] = {};
    }

    // Assign properties from the API response
    libraryStore.designElementsByType[typeId].designElementType = terraceData.designElementType;
    libraryStore.designElementsByType[typeId].designElementTypeId = typeId;
    libraryStore.designElementsByType[typeId].size = terraceData.size;

    // Process the design elements within this terrace type
    const processedElements = terraceData.designElements.map(de => {
      const isSelected = true;
      const isDisabled = !de.flagUpToDate;
      return {
        ...de, // Keep original properties
        isSelected,
        isDisabled
      };
    });
    libraryStore.designElementsByType[typeId].designElements = processedElements;
  };

  matchDEMMetadataToConfig(url: string, pixelSize: number): string {
    const matchedService = appConfig.demMapServices.find((service, index) => service.url === url.trim());
    if (matchedService === undefined) {
      return `DEM Service ${formatRoundSTrim(feetToMeters(pixelSize), 0)}M`
    }
    else {
      return matchedService.title;
    }
  }

  @action.bound getSurfaceDemSummary = (demSurfaceMetadata, designElementProjectResponseList) => {
    const reqDesignElementTypeId = 10;
    const surveyDemSurfaceElements = designElementProjectResponseList.find(el => el.designElementTypeId === reqDesignElementTypeId).designElements;
    if (!libraryStore.designElementsByType['Survey - DEM Surface']) {
      libraryStore.designElementsByType['Survey - DEM Surface'] = {};
    }
    libraryStore.designElementsByType['Survey - DEM Surface'].designElementType = 'Survey - DEM Surface';
    libraryStore.designElementsByType['Survey - DEM Surface'].designElementTypeId = 'Survey - DEM Surface';
    libraryStore.designElementsByType['Survey - DEM Surface'].size = demSurfaceMetadata.length;
    demSurfaceMetadata.forEach((el, index) => {
      el.isSelected = true;
      el.designElementName = el.demSurfaceName;
      el.designElementId = surveyDemSurfaceElements[index].designElementId;
      if (libraryStore.designElementsByType[10] && libraryStore.designElementsByType[10].designElements.length !== 0) {
        if (el.dataSourceType === 'User Defined') {
          libraryStore.designElementsByType[10].designElements[0].designElementName = 'Uploaded DEM';
        }
        else {
          libraryStore.designElementsByType[10].designElements[0].designElementName = this.matchDEMMetadataToConfig(el.metadata, el.demPixelSize);
        }
      }
    });
    libraryStore.designElementsByType['Survey - DEM Surface'].designElements = demSurfaceMetadata;
  };

  @action.bound getWaterwaySummary = (data) => {
    libraryStore.designElementsByType['Waterway'].designElements = data;
    libraryStore.designElementsByType['Waterway'].designElementType = 'Waterway';
    libraryStore.designElementsByType['Waterway'].designElementTypeId = appConfig.hardCodes.designElementTypeWaterway;
    libraryStore.designElementsByType['Waterway'].size = data.length;
    let wdtTypeId = 0;
    data.forEach((waterway) => {
      waterway.designElementId = waterway.alignedElementDesignParamsId;
      waterway.designElementName = waterway.name;
      waterway.isDisabled = true;
      if (waterway.waterwayType === 'Grassed') { wdtTypeId = 7 }
      if (waterway.waterwayType === 'Lined') { wdtTypeId = 19 }
      if (libraryStore.designElementsByType[wdtTypeId] && libraryStore.designElementsByType[wdtTypeId].designElements) {
        const waterwayExtraData = libraryStore.designElementsByType[wdtTypeId].designElements.find(
          (ex) => `${waterway.name.trim()}_${waterway.alignedElementDesignParamsId}` === ex.designElementName
        );
        if (waterwayExtraData) {
          waterway.flagId = waterwayExtraData.designElementId;
          waterway.isDisabled = waterwayExtraData.flagUpToDate;
        }
      }
      waterway.isSelected = !waterway.isDisabled;
    });
  };
  @action.bound getTerraceSummaryData = (data) => {
    libraryStore.designElementsByType['Terrace'].designElements = data;
    libraryStore.designElementsByType['Terrace'].designElementType = 'Terrace';
    libraryStore.designElementsByType['Terrace'].size = data.length;
    data.forEach((terrace) => {
      terrace.designElementId = terrace.alignedElementDesignParamsId;
      terrace.designElementName = terrace.name;
      terrace.isDisabled = true;
      if (libraryStore.designElementsByType[terrace.terraceTypeId] && libraryStore.designElementsByType[terrace.terraceTypeId].designElements) {
        const terraceExtraData = libraryStore.designElementsByType[terrace.terraceTypeId].designElements.find(
          (ex) => `${terrace.name.trim()}_${terrace.alignedElementDesignParamsId}` === ex.designElementName
        );
        if (terraceExtraData) {
          terrace.flagId = terraceExtraData.designElementId;
          terrace.isDisabled = terraceExtraData.flagUpToDate;
        }
      }
      terrace.isSelected = !terrace.isDisabled;
    });
  };

  @action.bound getUgoSummaryData = (data) => {
    libraryStore.designElementsByType['UGO'] = {};
    libraryStore.designElementsByType['UGO'].designElements = data;
    libraryStore.designElementsByType['UGO'].designElementType = 'UGO';
    libraryStore.designElementsByType['UGO'].size = data.length;
    data.forEach((ugo) => {
      ugo.designElementId = ugo.alignedElementDesignParamsId;
      ugo.designElementName = ugo.ugoName;
      ugo.isDisabled = true;

      if (libraryStore.designElementsByType[appConfig.hardCodes.designElementTypeUGO] &&
        libraryStore.designElementsByType[appConfig.hardCodes.designElementTypeUGO].designElements) {
        const ugoExtraData = libraryStore.designElementsByType[appConfig.hardCodes.designElementTypeUGO].designElements.find(
          (ex) => ex.designElementName.endsWith(`_${ugo.alignedElementDesignParamsId}`)
        );
        if (ugoExtraData) {
          ugo.flagId = ugoExtraData.designElementId;
          ugo.isDisabled = ugoExtraData.flagUpToDate;
        }
      }
      ugo.isSelected = !ugo.isDisabled;
    });
  };

  @action.bound getTerraceSystemSummaryData = async () => {
    // Store existing Terrace System selections to preserve user choices
    const existingTerraceSystemSelections = {};
    if (libraryStore.designElementsByType['Terrace System'] &&
      libraryStore.designElementsByType['Terrace System'].designElements) {
      libraryStore.designElementsByType['Terrace System'].designElements.forEach((element) => {
        existingTerraceSystemSelections[element.alignedElementDesignParamsId] = element.isSelected;
      });
    }

    libraryStore.designElementsByType['Terrace System'] = {
      designElementType: 'Terrace System',
      designElementTypeId: 'Terrace System',
    };

    const terraceSystemElements: any[] = [];

    // First, add UGO elements if they exist
    if (libraryStore.designElementsByType['UGO'] && libraryStore.designElementsByType['UGO'].designElements) {
      for (const ugo of libraryStore.designElementsByType['UGO'].designElements) {
        const existingSelection = existingTerraceSystemSelections[ugo.alignedElementDesignParamsId];
        const defaultSelection = libraryStore.fileFormat === 'Construction' ? false : !ugo.isDisabled;

        const ugoElement = observable({
          ...ugo,
          elementType: 'UGO' as const,
          terraceTypeId: null,
          // Only apply special Construction logic for Construction format
          isDisabled: libraryStore.fileFormat === 'Construction' ? true : ugo.isDisabled,
          isSelected: existingSelection !== undefined ? existingSelection : defaultSelection,
          ...(libraryStore.fileFormat === 'Construction' && { originallyEnabled: !ugo.isDisabled })
        });
        terraceSystemElements.push(ugoElement);
      };
    }

    // Then, add Terrace elements if they exist
    if (libraryStore.designElementsByType['Terrace'] && libraryStore.designElementsByType['Terrace'].designElements) {
      for (const terrace of libraryStore.designElementsByType['Terrace'].designElements) {
        // Preserve existing selection if it exists, otherwise default based on format
        const existingSelection = existingTerraceSystemSelections[terrace.alignedElementDesignParamsId];
        const defaultSelection = libraryStore.fileFormat === 'Construction' ? false : !terrace.isDisabled;

        let images: any = null;
        if (libraryStore.fileFormat === 'Images') {
          images = await this.getImagesByTerraceElementId(
            terrace.alignedElementDesignParamsId || terrace.designElementId
          );
          if (images) {
            Object.keys(images).forEach((key) => {
              images[key].forEach((el) => {
                if (el.structureProfilesId) libraryStore.selectedImages.push(el.structureProfilesId);
              });
            });
          }
        }

        const terraceElement = observable({
          ...terrace,
          elementType: 'Terrace' as const,
          terraceTypeId: terrace.terraceTypeId || null,
          isDisabled: libraryStore.fileFormat === 'Construction' ? true : terrace.isDisabled,
          isSelected:
            existingSelection !== undefined
              ? existingSelection
              : images
                ? true
                : defaultSelection,
          ...(libraryStore.fileFormat === 'Construction' && {
            originallyEnabled: !terrace.isDisabled,
          }),
          ...(images ? { images, hasImages: true } : {}),
        });
        terraceSystemElements.push(terraceElement);
      };
    }

    // Set the combined elements and size
    libraryStore.designElementsByType['Terrace System'].designElements = terraceSystemElements;
    libraryStore.designElementsByType['Terrace System'].size = terraceSystemElements.length;

    if (libraryStore.fileFormat === 'Images') {
      await this.getTerracePlanLocationImagery(this.project.sessionList[0].sessionUuid);
    };
  };
  @action.bound getSurveySummary = (data) => {
    libraryStore.designElementsByType['Survey'].designElementType = 'Survey';
    libraryStore.designElementsByType['Survey'].designElementTypeId = 'Survey';
    libraryStore.designElementsByType['Survey'].size = data.length;
    data.forEach((el) => {
      el.isSelected = true;
      el.designElementName = el.surveyName;
      el.designElementId = el.surveyId;
    });
    libraryStore.designElementsByType['Survey'].designElements = data;
  };

  @action.bound getImagesByDesignelement = async (designelement) => {
    try {
      const images = await StructureProfileController.getImageIdsByDesignElementIdUsingGET(
        designelement.designElementId
      );
      if (images && images.data && Object.values(images.data).some((el) => el.length > 0)) {
        designelement.images = images.data;
        designelement.hasImages = true;
        designelement.isSelected = true;
        Object.keys(designelement.images).forEach((key) =>
          designelement.images[key].forEach((el) => libraryStore.selectedImages.push(el.structureProfilesId))
        );
      }
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
    }
  };

  @action.bound async getImagesByTerraceElementId(id) {
    try {
      const images = await StructureProfileController.getImageIdsByDesignElementIdUsingGET(id);
      return images?.data && Object.values(images.data).some((el) => el.length > 0)
        ? images.data
        : null;
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
      return null;
    }
  }

  @action.bound getTerracePlanLocationImagery = async (sessionUuid) => {
    try {
      const images = await StructureProfileController.getPlanLocationImageIdsBySessionuuidUsingGET(sessionUuid);

      if (images && images.data) {
        const terraceImages = images.data.map(img => {
          return {
            imageTypeId: img.imageTypeId,
            imageName: img.imageTypeId === 1 ? 'Plan View' : 'Location View',
            imageId: img.structureProfilesId,
            isSelected: true,
            isDisabled: false
          };
        });

        libraryStore.designElementsByType['Terrace System'].terraceImages = terraceImages;

        terraceImages.forEach((img) => {
          if (img.imageId) libraryStore.selectedImages.push(img.imageId);
        });
      }
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
      MessageCenter.addError((error as Error).message);
    }
  };

  // ===================================================== //Load Data =====================================================

  @action.bound setInterval(e, alignment) {
    this.someChangesOnScreen();
    MessageCenter.clearMessages();
    alignment.interval = e.target.value;
  }

  @action.bound setIntervalWaterway(e, waterway) {
    this.someChangesOnScreen();
    MessageCenter.clearMessages();
    waterway.interval = e.target.value;
  }

  @action.bound setIntervalTerrace(e, terrace) {
    this.someChangesOnScreen();
    MessageCenter.clearMessages();
    terrace.interval = e.target.value;
  }

  @action.bound updateContent = async () => {
    if (libraryStore.fileFormat === 'Construction') { this.isLoading = libraryStore.isLoading }
    if (libraryStore.fileFormat === 'Design') { this.isLoading = libraryStore.isLoading }
    this.validTypes = OUTPUT_fileFormats[libraryStore.fileFormat].validTypes;

    // Only re-apply Terrace System logic when Terrace System is valid for current format
    if (this.validTypes.includes('Terrace System') &&
      (libraryStore.designElementsByType['Terrace'] || libraryStore.designElementsByType['UGO'])) {
      await this.getTerraceSystemSummaryData();
    }

    this.countElementsByFormat();
    this.someChangesOnScreen();
    if (this.project.projectClassId === projectClassId.hydrology) {
      this.selectedHydrologyType = OUTPUT_fileFormats[libraryStore.fileFormat].validTypes[0];
      this.selectAllHydrologyFiles(true, this.selectedHydrologyType);
    }
  };

  @action.bound countElementsByFormat = () => {
    this.countByFormat = 0;
    if (this.validTypes.length > 0) {
      this.validTypes.forEach((ty) => {
        if (libraryStore.designElementsByType[ty] && libraryStore.designElementsByType[ty].designElements) {
          if (libraryStore.fileFormat === "Images") {
            this.countByFormat += libraryStore.designElementsByType[ty].designElements.filter(el => el.images).length;
          } else {
            // Special case for Terrace System in Construction format: count selected elements even if disabled
            if (libraryStore.designElementsByType[ty].designElementType === 'Terrace System' && libraryStore.fileFormat === 'Construction') {
              this.countByFormat += libraryStore.designElementsByType[ty].designElements.filter(el => el.isSelected).length;
            } else {
              this.countByFormat += libraryStore.designElementsByType[ty].designElements.filter(el => !el.isDisabled && el.isSelected).length;
            }
          }
        }
      });
    }
  };

  @action.bound showAdded = (designTypeId, designtype) => {
    return (
      libraryStore.fileFormat === 'CSV' &&
      designTypeId === 'Waterway' &&
      designtype.designElements.some((el) => el.isSelected)
    );
  };

  @action.bound showAddtnlStations(e: any) {
    this.someChangesOnScreen();
    this.additionalStations = e.target.checked;
  }
  @action.bound showAddtnlStationsTerrace(e: any) {
    this.someChangesOnScreen();
    this.additionalStationsTerrace = e.target.checked;
  }

  // ================================================ Selections ================================================
  // changes fileFormat and validTypes variables - allows hiding designElements for certain file formats
  @action.bound selectFileFormatHandler = (e) => {
    libraryStore.fileFormat = e.target.value;
  };

  // select One Element
  @action.bound selectDesignElement = (e, element) => {
    this.someChangesOnScreen();
    element.isSelected = e.target.checked;
    this.countElementsByFormat();
  };

  @action.bound selectImage = (e, img) => {
    this.someChangesOnScreen();
    const i = libraryStore.selectedImages.indexOf(+e.target.value);
    if (e.target.checked) {
      if (i === -1) libraryStore.selectedImages.push(+e.target.value);
    } else {
      if (i > -1) libraryStore.selectedImages.splice(i, 1);
    }
    img.isSelected = libraryStore.selectedImages.includes(img.imageId);
  };

  @action.bound selectImageType = (checked, img) => {
    this.someChangesOnScreen();
    const i = libraryStore.selectedImages.indexOf(img.imageId);
    if (checked) {
      if (i === -1) libraryStore.selectedImages.push(img.imageId);
    } else {
      if (i > -1) libraryStore.selectedImages.splice(i, 1);
    }
    img.isSelected = libraryStore.selectedImages.includes(img.imageId);
  };

  // select All in Type
  @action.bound selectAllByTypeHandler = (e, typeId) => {
    this.someChangesOnScreen();
    if (libraryStore.fileFormat === 'Images') {
      libraryStore.designElementsByType[typeId].designElements
        .filter((el) => el.images)
        .forEach((el) =>
          Object.keys(el.images).forEach((key) => selectImageTypeHandler(e.target.checked, el.images[key], el))
        );
      if (typeId === 'Terrace System') {
        libraryStore.designElementsByType[typeId].terraceImages.forEach((img) => this.selectImageType(e.target.checked, img))
      };
    } else {
      if (libraryStore.designElementsByType[typeId].designElementType === 'Terrace System' && libraryStore.fileFormat === 'Construction') {
        libraryStore.designElementsByType[typeId].designElements.forEach((el) => {
          if (e.target.checked) {
            el.isSelected = el.originallyEnabled || false;
          } else {
            el.isSelected = false;
          }
        });
      } else {
        libraryStore.designElementsByType[typeId].designElements
          .filter((el) => !el.isDisabled)
          .forEach((el) => (el.isSelected = e.target.checked));
      }
    }
    this.countElementsByFormat();
  };

  @action.bound selectAllHandler = () => {
    this.someChangesOnScreen();
    if (this.project.projectClassId === projectClassId.design) {
      this.setIsSelectedToAllTypes(true);
    }
  };

  @action.bound setIsSelectedToAllTypes = (value) => {
    this.validTypes.forEach((ty) => {
      if (libraryStore.designElementsByType[ty] && libraryStore.designElementsByType[ty].designElements) {
        libraryStore.designElementsByType[ty].designElements
          .filter((el) => !el.isDisabled)
          .forEach((el) => {
            el.isSelected = value;
            if (libraryStore.fileFormat === 'Images' && el.images) {
              selectStructureHandler(value, el);
              if (ty === 'Terrace System') {
                libraryStore.designElementsByType[ty].terraceImages.forEach((img) => this.selectImageType(value, img))
              };
            }
          });
      }
    });
    this.countElementsByFormat();
  };

  @action.bound designTypeIsChecked = (designtype) => {
    if (libraryStore.fileFormat === 'Images') {
      if (designtype.designElementType === 'Terrace System') {
        const elementImagesSelected = !designtype.designElements
          .filter((el) => el.images)
          .some((el) => !el.isSelected);

        const terraceImagesSelected = designtype.terraceImages?.length > 0
          ? designtype.terraceImages.some((img) => img.isSelected)
          : false;

        return elementImagesSelected || terraceImagesSelected;
      }

      if (designtype.designElements.filter((el) => el.images).length > 0) {
        return !designtype.designElements.filter((el) => el.images).some((el) => !el.isSelected);
      } else {
        return false;
      }
    } else {
      if (designtype.designElementType === 'Terrace System' && libraryStore.fileFormat === 'Construction') {
        return designtype.designElements.some((el) => el.isSelected);
      }

      const activeEl = designtype.designElements.filter((el) => !el.isDisabled);
      if (activeEl.length > 0) {
        return !activeEl.some((el) => !el.isSelected);
      } else {
        return false;
      }
    }
  };
  @action.bound getTotalAvailableElements = () => {
    let total = 0;
    if (this.validTypes.length > 0) {
      this.validTypes.forEach((ty) => {
        if (libraryStore.designElementsByType[ty] && libraryStore.designElementsByType[ty].designElements) {
          if (libraryStore.fileFormat === "Images") {
            total += libraryStore.designElementsByType[ty].designElements.filter(el => el.images).length;
          } else {
            if (libraryStore.designElementsByType[ty].designElementType === 'Terrace System' && libraryStore.fileFormat === 'Construction') {
              total += libraryStore.designElementsByType[ty].designElements.length;
            } else {
              // Only count elements that are not disabled
              total += libraryStore.designElementsByType[ty].designElements.filter(el => !el.isDisabled).length;
            }
          }
        }
      });
    }
    return total;
  };
  // ================================================ //Selections ================================================

  @action.bound clearAllHandler = () => {
    this.someChangesOnScreen();
    if (this.project.projectClassId === projectClassId.design) {
      this.setIsSelectedToAllTypes(false);
      libraryStore.selectedImages.length = 0;
      this.countElementsByFormat();
    } else if (this.currentSubTab === ANALYSIS) {
      this.selectedHydrologyFiles.length = 0;
    }
  };

  @action.bound cancelHandler = (e) => {
    this.setIsSelectedToAllTypes(false);
    libraryStore.designElementsByType = {};
    this.selectedHydrologyFiles.length = 0;
    libraryStore.selectedImages.length = 0;
    this.props.toggleDownloadPopup();
  };

  @action.bound someChangesOnScreen = () => {
    if (this.project.projectClassId === projectClassId.design) {
      this.formValidation = { ...this.initialformValidation };
      this.successGeneratingFile = false;
      this.fileLocation = '';
    }
  };

  @action.bound submitHandler = (e) => {
    this.setLoader('Generating file...');
    // Validation
    if (this.project.projectClassId === projectClassId.design) {
      // DesignElement
      const count = this.validTypes.reduce(
        (acc, typeId) =>
          acc + (libraryStore.designElementsByType[typeId]
            ? libraryStore.designElementsByType[typeId]!.designElements!.length
            : 0),
        0
      );
      if (count === 0) {
        this.formValidation.formErrors.selectedElements = OUTPUT_fileFormats[libraryStore.fileFormat].errorMsg;
        return;
      }
    }

    this.generateFile();
  };

  @action.bound async generateFile() {
    this.setLoader('Generating File...');
    this.fileLocation = '';
    try {
      switch (libraryStore.fileFormat) {
        case 'LandXML':
          // Creating LandXML payload
          const LandXMLpayload: any = [];
          this.validTypes.forEach((typeId) => {
            if (
              libraryStore.designElementsByType[typeId] &&
              libraryStore.designElementsByType[typeId].designElements.length > 0
            ) {
              libraryStore.designElementsByType[typeId].designElements
                .filter((el) => el.isSelected)
                .forEach((el) => {
                  let designElementType = libraryStore.designElementsByType[typeId].designElementTypeId;
                  if (designElementType === 'Survey - DEM Surface') {
                    designElementType = 10;
                  }
                  if (el.terraceTypeId) {
                    LandXMLpayload.push({
                      designElementId: el.flagId ? el.flagId : el.designElementId,
                      designElementType: el.terraceTypeId,
                    })
                  } if (el.waterwayType) {
                    LandXMLpayload.push({
                      designElementId: el.flagId ? el.flagId : el.designElementId,
                      designElementType: el.waterwayType === "Lined" ? 19 : appConfig.hardCodes.designElementTypeWaterway
                    })
                  } else {
                    LandXMLpayload.push({
                      designElementId: el.flagId ? el.flagId : el.designElementId,
                      designElementType: +designElementType
                    });
                  }
                });
            }
          });
          // Generating LandXML file
          const landXMLresponse: any = await SurfaceController.generateLandXMLUsingPOST(LandXMLpayload);
          if (landXMLresponse && landXMLresponse.data.landXMLFileName) {
            this.fileLocation =
              setEndpoints.baseSetPath + setEndpoints.downloadLandXML + '/' + landXMLresponse.data.landXMLFileName;
            this.successGeneratingFile = true;
          } else {
            this.formValidation.formErrors.selectedElements = 'LandXML file generation failed';
            MessageCenter.addNotificationFromCode(landXMLresponse.data.errorResponse.errorCode);
          }
          break;

        case 'ESRI':
          // Creating ESRI payload
          const ids: any[] = [];
          const waterwayPayload: any[] = [];
          const terracePayload: any[] = [];
          this.validTypes.forEach((typeId) => {
            if (
              libraryStore.designElementsByType[typeId] &&
              libraryStore.designElementsByType[typeId].designElements.length > 0
            ) {
              libraryStore.designElementsByType[typeId].designElements
                .filter((el) => el.isSelected)
                .forEach((el) => {
                  if (typeId === 'Waterway') {
                    waterwayPayload.push({ alignedElementId: el.designElementId, alignedElementType: 7 });
                  } else if (typeId === 'Terrace') {
                    terracePayload.push({ alignedElementId: el.designElementId, alignedElementType: el.terraceTypeId })
                  } else {
                    ids.push(el.designElementId);
                  };
                });
            }
          });

          const idsString = ids.join();
          const jsonData = ids.length > 0 ? await this.getDesignElementJsonData(idsString) : [];
          const waterwayJsonData = await this.getAlignedElementJsonData(waterwayPayload);
          const terraceJsonData = await this.getTerraceChannelShapeJsonData(terracePayload);
          const jsonDataString: string = JSON.stringify([...jsonData, ...waterwayJsonData, ...terraceJsonData]);
          // Generating ESRI file
          await invokeExportZipHandler(
            idsString,
            jsonDataString,
            appConfig.tempHardCodes.wkid,
            this.project.projectUuid
          ); // , '', 11); ID (11) not needed
          if (setStore.shapeFilesExportZipUrl) this.successGeneratingFile = true;
          break;

        case 'CSV':
          // Creating CSV payload
          const combinedPayload: DesignElementDownloadDTO = {
            alignmentExportRequest: [],
            landLevelingExportRequest: [],
            projectName: this.project.projectTitle,
            projectUuid: this.project.projectUuid,
            surveyExportRequest: [],
            waterwayExportRequest: [],
          };
          this.exportTerraceRequest = [];
          this.validTypes.forEach((typeId) => {
            if (
              libraryStore.designElementsByType[typeId] &&
              libraryStore.designElementsByType[typeId].designElements.length > 0
            ) {
              libraryStore.designElementsByType[typeId].designElements
                .filter((el) => el.isSelected)
                .forEach((el) => {
                  if (typeId == 5) {
                    // Alignments
                    combinedPayload.alignmentExportRequest!.push({
                      alignmentId: el.designElementId,
                      alignmentName: el.designElementName,
                      designElementId: el.designElementId,
                      sampleInterval: el.interval ? Number(el.interval) : 0,
                      sampling: el.interval ? 1 : 0,
                    });
                  } else if (typeId == 15) {
                    // Lend Leveling
                    combinedPayload.landLevelingExportRequest!.push({
                      structureDesignElementId: el.designElementId,
                      surfaceDesignElementId: this.surfaceDefId,
                    });
                  } else if (typeId === 'Waterway') {
                    // Waterways
                    let crossSectionIntervalValue = 0;
                    if (this.additionalStations) {
                      crossSectionIntervalValue = el.interval ? el.interval : 6;
                    }

                    combinedPayload.waterwayExportRequest!.push({
                      alignedElementDesignParametersId: el.alignedElementDesignParamsId,
                      crossSectionInterval: crossSectionIntervalValue,
                    });
                    if (this.additionalStations && !el.interval) MessageCenter.addNotificationFromCode('WDT_116');
                  } else if (typeId === 'Survey') {
                    // Surveys
                    combinedPayload.surveyExportRequest!.push({
                      surveyId: el.surveyId,
                      surveyName: el.surveyName,
                      surveyType: el.surveyType,
                    });
                  }
                  else if (typeId === 'Terrace') {
                    //Terraces if Applicable
                    let terraceIntervalValue: number = 6;
                    if (this.additionalStationsTerrace) {
                      terraceIntervalValue = el.interval ? el.interval : 6;
                    }
                    this.exportTerraceRequest.push({
                      terraceID: el.alignedElementDesignParamsId, //el.alignedElementDesignParametersId,
                      terraceCrossSection: terraceIntervalValue, //if Applicable for Terraces
                      name: el.designElementName,
                    });
                    if (this.additionalStationsTerrace && !el.interval) MessageCenter.addNotificationFromCode('WDT_116');
                  }
                });
            }
          });
          try {
            if (combinedPayload.alignmentExportRequest?.length || combinedPayload.waterwayExportRequest?.length || combinedPayload.surveyExportRequest?.length || combinedPayload.landLevelingExportRequest?.length) {
              const response: any = await DesignElementExportController.submitDownloadForAllDesignElementsCSVUsingPOST(
                this.project.projectUuid,
                this.project.projectTitle,
                true,
                combinedPayload
              );
              if (response.data) {
                this.fileLocation = setEndpoints.baseSetPath + setEndpoints.downloadLandXML + '/' + response.data;
                this.successGeneratingFile = true;
              }
            }
            this.capturedCSVs = []
            for (const selectedTerrace of this.exportTerraceRequest) {
              const capture: any = await TerraceDesignToolsController.exportTerraceCrossSectionsUsingPOST(selectedTerrace.terraceID, selectedTerrace.terraceCrossSection);
              if (capture.data) {
                this.capturedCSVs.push({
                  response: capture,
                  name: selectedTerrace.name
                });
                this.successGeneratingFile = true;
              }
            }
          } catch (error) {
            console.error(error);
            this.error = true;
            this.errorMsg = (error as Error).message;
          }
          break;

        case 'DEM':
          try {
            const response: any = await SurfaceDefController.getDEMOutletsUsingGET(this.project.sessionList[0].sessionUuid)
            if (response && response.data && response.data.errorResponse) {
              MessageCenter.addError(response.data.errorResponse.errorMessage, [], response.data.errorResponse.errorCode);
            }
            if (response.data && response.data.fileName) {
              this.fileLocation = setEndpoints.basePath + setEndpoints.downloadDEM + '/' + this.project.projectUuid + `/${response.data.fileName}`;
              this.successGeneratingFile = true;
            }
          } catch (error) {
            console.error(error);
          }
          break;
        case 'Images':
          try {
            const response: any = await StructureProfileController.getImagesZipFileBySelectedImageIdsUsingPOST([
              ...libraryStore.selectedImages,
            ]);

            if (response && response.data && response.data.errorResponse) {
              MessageCenter.addError(response.data.errorResponse.errorMessage, [], response.data.errorResponse.errorCode);
            }

            if (response.data && response.data.zipFileName) {
              this.fileLocation =
                setEndpoints.baseSetPath + setEndpoints.downloadLandXML + '/' + response.data.zipFileName;
              this.successGeneratingFile = true;
            }
          } catch (error) {
            console.error(error);
            this.error = true;
            this.errorMsg = (error as Error).message;
          }
          break;

        default:
          break;
      }
      this.error = false;
    } catch (error) {
      this.error = true;
      this.errorMsg = (error as Error).message;
    } finally {
      this.setLoader('');
    }
  }

  @action.bound downloadHandler = async (e) => {
    e.preventDefault();
    this.isLoading = true;
    const link = document.createElement('a');
    if (libraryStore.fileFormat === 'LandXML') {
      const arr = this.fileLocation.split('/');
      const filename = arr[arr.length - 1];
      const response = await SurfaceController.downloadFileUsingGET1(filename);
      if (response.data) {
        this.accessTokenDownloadLandXML = response.config.headers?.Authorization as string ?? "";
        document.body.appendChild(link);

        const headers = new Headers();
        headers.append('Authorization', this.accessTokenDownloadLandXML);

        fetch(this.fileLocation, { headers })
          .then((response) => response.blob())
          .then((blobby) => {
            const objectUrl = window.URL.createObjectURL(blobby);
            link.href = objectUrl;
            link.download = this.fileLocation.substring(this.fileLocation.lastIndexOf('/') + 1);
            link.click();
            window.URL.revokeObjectURL(objectUrl);
          });
      }
    } else if (libraryStore.fileFormat === 'ESRI') {
      link.href = setStore.shapeFilesExportZipUrl;
    } else if (libraryStore.fileFormat === 'CSV') {
      // exceptional terrace download
      for (const csv of this.capturedCSVs) {
        const others: any = document.createElement('a');
        document.body.appendChild(others);
        others.download = `Terrace_${csv.name}_XSection.csv`;
        others.href = `data:${csv.response.headers['content-type']}, ` + encodeURIComponent(csv.response.data)
        others.click();
      }
      // Normal download
      link.href = this.fileLocation;
      link.download = this.fileLocation.substring(this.fileLocation.lastIndexOf('/') + 1);
    } else if (libraryStore.fileFormat === 'Images') {
      link.href = this.fileLocation;
    } else if (libraryStore.fileFormat === 'DEM') {
      const filename = this.fileLocation.split("/");
      this.fileLocation = this.fileLocation.replace(`/${filename[filename.length - 1]}`, '');
      const headers = new Headers();
      headers.append('Authorization', "Bearer " + localStorage.getItem('accessToken')!);
      fetch(this.fileLocation, { headers })
        .then((response) => response.blob())
        .then((blobby) => {
          const objectUrl = window.URL.createObjectURL(blobby);
          link.href = objectUrl;
          link.download = filename[filename.length - 1];
          link.click();
          window.URL.revokeObjectURL(objectUrl);
        });
    }

    if (libraryStore.fileFormat !== 'LandXML' && libraryStore.fileFormat !== "DEM") {
      link.click();
    }
    this.addActivityDownloadtrack();
    this.someChangesOnScreen();
    this.isLoading = false;
  };

  @action.bound async addActivityDownloadtrack() {
    this.designTypeComments.length = 0;
    this.validTypes.forEach((typeId) => {
      const designtype = libraryStore.designElementsByType[typeId];
      if (designtype && designtype.designElements && designtype.designElements.length > 0) {
        const activeElementsSize = designtype.designElements.filter((el) => el.isSelected).length;
        let comment = '';
        if (activeElementsSize > 1) {
          comment = `${activeElementsSize} ${designtype.designElementType}s`;
        } else if (activeElementsSize === 1) {
          comment = `${activeElementsSize} ${designtype.designElementType}`;
        }
        if (comment) {
          this.designTypeComments.push(comment);
        }
      }
    });

    const postJSON: ICreateActivityLogPOST = {
      projUuid: this.project.projectUuid,
      sessionUuid: this.project.sessionList[0].sessionUuid,
      userName: this.project.createdBy,
      comment: `Downloaded ${libraryStore.fileFormat} ${this.designTypeComments.join(', ')}`,
      activityContent: 'Create Activity',
      appAccessed: 'SET',
      crudCode: 'Create',
      projectStatus: 'Started',
    };
    try {
      await ActivityLogController.createActivityLogUsingPOST(postJSON);
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    }
  }

  async getDesignElementJsonData(ids: string): Promise<any> {
    const response = await DesignElementController.surveyDesignElementByIdUsingGET(ids);
    const jsonData: any[] = response.data.map((element) => {
      return {
        element_id: element.designElementId,
        json: JSON.parse(element.json as string),
        type_id: element.designElementTypeId,
      };
    });
    return jsonData;
  }

  async getAlignedElementJsonData(payload): Promise<any> {
    const promises = payload.map(async (el) => {
      const response = await WaterwayDesignToolsController.getAlignedElementShapeByAlignedElementIdUsingGET(
        el.alignedElementId
      );
      const data = response.data;
      const shapeJson = data.alignedFeatureDesignShapeJson
        ? JSON.parse(data.alignedFeatureDesignShapeJson).alignedStructureShapeDTO
        : null;
      return {
        element_id: data.alignedElementDesignParamsId,
        json: shapeJson,
        type_id: el.alignedElementType,
      };
    });
    const jsonData = await Promise.all(promises);
    return jsonData;
  }
  async getTerraceChannelShapeJsonData(payload): Promise<any> {
    const promises = payload.map(async (el) => {
      const response = await TerraceDesignToolsController.calculateTerraceChannelShapeUsingPOST(el.alignedElementId)
      const data = response.data;
      const shapeJson = data.terraceStructureShapeDTO ? data.terraceStructureShapeDTO : null;
      return {
        element_id: data.alignedElementDesignParamsId,
        json: shapeJson,
        type_id: el.alignedElementType,
      };
    });
    const jsonData = await Promise.all(promises);
    return jsonData;
  }

  // ================================================ HYDROLOGY ================================================
  @observable hydrologyDownloads: any = [];
  @observable selectedHydrologyType: string = '';
  @observable selectedHydrologyFiles: any = [];

  @action.bound selectHydrologyType = (e) => {
    const { value, checked } = e.target;
    if (OUTPUT_TYPES[value].options.length === 0) this.selectedHydrologyType = value;
    this.selectAllHydrologyFiles(checked, value);
  };

  @action.bound selectAllHydrologyFiles = (selectAll, value) => {
    if (OUTPUT_TYPES[value] && OUTPUT_TYPES[value].options) {
      if (selectAll) {
        this.selectedHydrologyFiles = [];
        OUTPUT_TYPES[value].options.forEach((el) => this.selectedHydrologyFiles.push(el.value));
      } else {
        this.selectedHydrologyFiles = [];
      }
    }
  };

  @action.bound selectHydrologyImage = (index?: number) => {
    if (index === undefined) {
      // Select or deselect all
      const shouldSelectAll = !this.hydrologyImages.every(image => image.selected);
      this.hydrologyImages.forEach(element => element.selected = shouldSelectAll);
    } else {
      this.hydrologyImages[index].selected = !this.hydrologyImages[index].selected;
    }
    this.isAllHydrologyImagesSelected();
  }

  @action.bound isAllHydrologyImagesSelected = () => this.hydrologyImages.every(image => image.selected === true);


  @action.bound selectHydrologyFile = (e) => {
    if (e.target.type === 'radio') this.selectedHydrologyFiles = [];
    const i = this.selectedHydrologyFiles.indexOf(e.target.value);
    if (i === -1) {
      this.selectedHydrologyFiles.push(e.target.value);
    } else {
      this.selectedHydrologyFiles.splice(i, 1);
    }
  };

  getDate = () => {
    const date = new Date();
    const fixedSlice = -2;
    const dateStr =
      ('00' + (date.getMonth() + 1)).slice(fixedSlice) +
      ('00' + date.getDate()).slice(fixedSlice) +
      date.getFullYear() +
      ('00' + date.getHours()).slice(fixedSlice) +
      ('00' + date.getMinutes()).slice(fixedSlice);
    return dateStr;
  };

  @action.bound getProjectAttachments = async () => {
    let url = '';
    this.setLoader(this.retrevingFilesString);
    try {
      const response: any = await HydroControllerApi.getHydroProjectAttachmentsByProjectUuidUsingGET(
        this.project.projectUuid
      );
      if (response.data.length > 0) {
        const GPSessionUuid = response.data[0].projectFileName;
        const projectName = this.project.projectTitle;
        this.hydrologyDownloads.push(response.data[0]);
        url = await this.createGISFilesLink(GPSessionUuid, projectName);
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.setLoader('');
    }
    return url;
  };

  @action.bound async createGISFilesLink(gpSessionId, projectName) {
    let link = '';
    if (gpSessionId) {
      try {
        const result = await this.watershedApi.exportSessionEfh2(gpSessionId, projectName);
        link = result;
      } catch (error) {
        console.error(error);
      }
    }
    this.hydrologyDownloads[0].url = link;
    this.hydrologyDownloads[0].download = true;
    return link;
  }

  @action.bound async downloadReport() {
    this.setLoader(this.retrevingFilesString);
    const allPayload: HydrologyReportReqDto = {
      runOffPeakDisEnabled: this.selectedHydrologyFiles.includes('runoff') ? true : false,
      aoiMapEnabled: this.selectedHydrologyFiles.includes('aoi') ? true : false,
      rainfallDistEnabled: this.selectedHydrologyFiles.includes('rainfall') ? true : false,
      precpFreqDataEnabled: this.selectedHydrologyFiles.includes('precipitation') ? true : false,
      hydrographWithStrmAnlyEnabled: this.selectedHydrologyFiles.includes('storm') ? true : false,
      demServiceEnabled: this.selectedHydrologyFiles.includes('dem') ? true : false,
      metadataEnabled: this.selectedHydrologyFiles.includes('peak') ? true : false,
      commentsEnabled: true,
      projectUuid: this.project.projectUuid,
    };
    const response = await HydroControllerApi.generateEfh2PdfReportsGUsingPOST(allPayload, undefined, {
      responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(new Blob([response.data as any]));
    this.setLoader('');
    return blobUrl;
  }

  @action.bound async downloadDetails() {
    this.setLoader(this.retrevingFilesString);
    const response = await HydroControllerApi.downloadEfh2DetailsUsingGET(this.project.projectUuid, undefined, {
      responseType: 'blob',
    });
    const blobUrl = URL.createObjectURL(new Blob([response.data as any]));
    this.setLoader('');
    return blobUrl;
  }

  @action.bound downloadImages() {
    this.setLoader(this.retrevingFilesString);
    this.hydrologyImages.filter(image => image.selected).forEach((image, index) => {
      const dataUrl = `data:image/png;base64,${image.image}`;
      const link = document.createElement('a');
      link.href = dataUrl;
      const fileName = `NETS_Hydrology_${this.project.projectTitle}_${image.name}_${this.getDate()}.png`;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    this.setLoader('');
  }


  // ================================================ //HYDROLOGY ================================================
}
